const host = window.location.host;
//* 如果想要在本地调试线上环境，手动取消下面这行代码的注释：
// const isProd = true;
const localHosts = ["localhost:8080", "localhost:8082", "127.0.0.1:8080", "127.0.0.1:8082", "192.168.0.39:8080", "192.168.0.39:8081", "192.168.0.39:8082", "192.168.0.39:8083", "192.168.0.39:8086", "192.168.0.36:8082", "192.168.0.36:8084"];
const isProd = !localHosts.includes(host);
//! 但一定要在推送代码/打包时改回到上面这行代码！

// const baseUrl = isProd ? 'http://cqu.cxstar.cn/' : 'https://xcu-trial.cxstar.cn /'
// const baseUrl = isProd ? 'http://192.168.0.4:5566/' : 'http://192.168.0.4:5566/'
// const localUrl = isProd ? `${window.location.origin}` : `https://cxaitest.cxstar.cn`;
// const baseUrl = isProd ? `${window.location.origin}/` : `https://cxaitest.cxstar.cn/`;
// const fileUrl = isProd ? `${window.location.origin}/` : `https://cxaitest.cxstar.cn/`;
// const AIsearch = `https://jyx.cxstar.cn/`;
let localUrl = isProd ? `https://jyx.cxstar.cn/` : `https://cxaitest.cxstar.cn/`;
let baseUrl = isProd ? `https://jyx.cxstar.cn/` : `https://cxaitest.cxstar.cn/`;
let fileUrl = isProd ? `https://jyx.cxstar.cn` : `https://cxaitest.cxstar.cn`;
let jyxUrl = isProd ? `https://jyx.cxstar.cn/` : `https://cxaitest.cxstar.cn/`;

if (host === "cxaitest.cxstar.cn") {
  localUrl = `https://cxaitest.cxstar.cn/`;
  baseUrl = `https://cxaitest.cxstar.cn/`;
  fileUrl = `https://cxaitest.cxstar.cn`;
  jyxUrl = `https://cxaitest.cxstar.cn/`;
} else if (host === "cxai.cxstar.cn" || host === "jyx.cxstar.cn") {
  localUrl = `https://jyx.cxstar.cn/`;
  baseUrl = `https://jyx.cxstar.cn/`;
  fileUrl = `https://jyx.cxstar.cn`;
  jyxUrl = `https://jyx.cxstar.cn/`;
}

// const localUrl = `http://jyxtest118.cxstar.cn/`;
// const baseUrl = `http://jyxtest118.cxstar.cn/`;
// const fileUrl = `http://jyxtest118.cxstar.cn/`;
// const AIsearch = `http://jyxtest118.cxstar.cn/`;

// const fileUrl = isProd `https://${window.location.host}/` : `https://cxaitest.cxstar.cn/`;
// const localUrl = isProd ? 'https://cqu.cxstar.cn' : 'https://cqu.cxstar.cn'
// const baseUrl = isProd ? 'https://cqu.cxstar.cn/' : 'https://cqu.cxstar.cn/'
// const fileUrl = isProd ? 'https://cqu.cxstar.cn/' : 'https://cqu.cxstar.cn/'
export default {
  baseUrl,
  fileUrl,
  localUrl,
};
